export const asWarning = {
  data: `<svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.00008 3.3265L13.0201 11.9998L2.98008 11.9998L8.00008 3.3265ZM8.00008 0.666504L0.666748 13.3332L15.3334 13.3332L8.00008 0.666504ZM8.66675 9.99984H7.33341V11.3332H8.66675V9.99984ZM8.66675 5.99984H7.33341V8.6665H8.66675V5.99984Z"/>
  </svg>
  `,
  name: 'warning',
};
